import { useState, useEffect } from 'react'

interface CurrencyInfo {
  symbol: string
  code: string
  price: number
  formatPrice: () => string
}

export function useCurrency(): CurrencyInfo {
  const [currency, setCurrency] = useState<CurrencyInfo>({
    symbol: '$',
    code: 'MXN',
    price: 229.99,
    formatPrice: () => '$229.99 MXN',
  })

  useEffect(() => {
    try {
      const lang = navigator.language.toLowerCase()

      let symbol = '$'
      let code = 'MXN'
      let price = 229.99

      if (lang.includes('es-mx')) {
        symbol = '$'
        code = 'MXN'
        price = 229.99
      } else if (lang.includes('en-us') || lang === 'en') {
        symbol = '$'
        code = 'USD'
        price = 12.99
      } else if (lang.includes('en-gb')) {
        symbol = '£'
        code = 'GBP'
        price = 10.99
      } else if (
        ['de', 'fr', 'it', 'es-es', 'pt'].some((l) => lang.includes(l))
      ) {
        symbol = '€'
        code = 'EUR'
        price = 11.99
      } else if (lang.includes('es')) {
        // Other Spanish speaking countries default to USD for international digital products usually,
        // but we'll keep MXN as default per prompt or USD. Let's use USD for general LATAM if not MX.
        symbol = '$'
        code = 'USD'
        price = 12.99
      }

      setCurrency({
        symbol,
        code,
        price,
        formatPrice: () => `${symbol}${price} ${code}`,
      })
    } catch (error) {
      // Fallback to default if navigator is not available
      console.error('Error detecting locale', error)
    }
  }, [])

  return currency
}
